import React, { useState, useEffect } from 'react';
import { cloudAPI } from '../../utils/api';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function GrowthPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getGrowth()
            .then(res => {
                const d = res.data;
                const rows = Array.isArray(d) ? d
                           : Array.isArray(d?.data) ? d.data
                           : Array.isArray(d?.rows) ? d.rows
                           : [];
                setData(rows);
            })
            .catch(err => console.error('Growth error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Growth</h2>
            <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Daily Active Users</h3>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="day" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="dau" name="DAU" stroke="#667eea" strokeWidth={2} />
                        <Line type="monotone" dataKey="dac" name="DAC" stroke="#f093fb" strokeWidth={2} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
